import { NgClass } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  imports: [NgClass],
  selector: 'app-dots-spinner',
  styles: [
    `
      .dots-spinner {
        position: relative;
        width: 24px;
        height: 24px;
      }

      .dot {
        position: absolute;
        background-color: var(--dot-color, var(--shikenso-purple-base));
        border-radius: 50%;
        top: 50%;
        left: 50%;
        transform-origin: 0 0;
      }

      .dot:nth-child(5) {
        width: 4px;
        height: 4px;
        animation: rotate 0.8s linear infinite -0.32s;
      }

      .dot:nth-child(4) {
        width: 3.5px;
        height: 3.5px;
        animation: rotate 0.8s linear infinite -0.24s;
      }

      .dot:nth-child(3) {
        width: 3px;
        height: 3px;
        animation: rotate 0.8s linear infinite -0.16s;
      }

      .dot:nth-child(2) {
        width: 2.5px;
        height: 2.5px;
        animation: rotate 0.8s linear infinite -0.08s;
      }

      .dot:nth-child(1) {
        width: 2px;
        height: 2px;
        animation: rotate 0.8s linear infinite;
      }

      @keyframes rotate {
        0% {
          transform: rotate(0deg) translateX(6px);
        }
        100% {
          transform: rotate(360deg) translateX(6px);
        }
      }
    `,
  ],
  template: `
    <div
      class="dots-spinner"
      [style.--dot-color]="dotsColor()"
      [ngClass]="{ 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2': absoluteCentered() }"
    >
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  `,
})
export class DotsSpinnerComponent {
  public readonly color = input<string | 'white'>('var(--shikenso-purple-base)');
  public readonly absoluteCentered = input<boolean>(false);

  public readonly dotsColor = computed(() => (this.color() === 'white' ? 'var(--shikenso-base-white)' : this.color()));
}
